module.exports = __webpack_public_path__ + "static/img/routedes1.ce0653d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/routedes1.png
// module id = feoy
// module chunks = 0